import { useMutation, useQuery, useQueryClient } from "react-query"
import api from "../api";
import { API_ROUTES } from "../../utils/const";

const CREATE_NEW_STABLE_COIN_WALLET = async ({
  businessId,
  currencyCode,
  userId,
  token
}) => {
  const response = await api.post(API_ROUTES.CREATE_STABLE_COIN_WALLET, {
    businessId,
    currencyCode,
    userId,
  },
    {
      headers: {
        "x-auth-token": token,
      },
    }
  )
  return response.data;
}

export const createNewStableCoinWallet = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: CREATE_NEW_STABLE_COIN_WALLET,
    onSuccess: () => {
      queryClient.invalidateQueries(["stableCoins"]);
    },
  })
}


type StableCoinNetworkOptions = { label: string, value: string }

const FETCH_STABLE_COIN_TXN_NETWORKS = async (currency: string): Promise<StableCoinNetworkOptions[]> => {
  const response = await api.get(`${API_ROUTES.GET_STABLE_COIN_NETWORKS}?currency=${currency}`)
  const mappedData = response.data.data.map((item: { network: string, code: string, currency: string }) => ({
    label: item.network,
    value: item.code
  }))
  return mappedData;
}

export const useStableCoinNetworks = ({ currency, businessId }: { currency: string, businessId: string }) => {
  return useQuery({
    queryKey: ["stableCoinNetworks", currency],
    queryFn: () => FETCH_STABLE_COIN_TXN_NETWORKS(currency),
    enabled: !!businessId,
  })
}


type StableCoinPayoutFees = { amount: number, currency: string, fee: number, flow: string, totalDebit: number }

const FETCH_STABLE_COIN_FEE = async (params): Promise<StableCoinPayoutFees> => {
  const response = await api.get(`${API_ROUTES.GET_STABLE_COIN_FEE}`, {
    params: { ...params }
  })
  return response.data.data;
}

export const useStableCoinFee = (businessId, params) => {
  return useQuery({
    queryKey: ["stableCoinPayoutFee", params],
    queryFn: () => FETCH_STABLE_COIN_FEE(params),
    enabled: !!businessId && !!params.amount && !!params.network,
  })
}




type StableCoinPayoutPayloadType = {
  data: Record<string, unknown>;
  token: string
}

const STABLE_COIN_PAYOUT = async ({ data, token }: StableCoinPayoutPayloadType) => {
  const response = await api.post(API_ROUTES.STABLE_COIN_PAYOUT, data,
    {
      headers: {
        "x-auth-token": token,
      },
    }
  )
  return response.data
}

export const useStableCoinPayout = () => {
  return useMutation({
    mutationFn: (payload: StableCoinPayoutPayloadType) => STABLE_COIN_PAYOUT(payload),
  })
}


type FetchStableCoinWalletParams = {
  network: string;
  token: string;
};

type StableCoinWalletAddressResponse = {
  id: number;
  walletId: number;
  userId: number | null;
  businessId: number;
  currency: string;
  network: string;
  address: string;
}

const FETCH_STABLE_COIN_WALLET = async ({ network, token }: FetchStableCoinWalletParams): Promise<StableCoinWalletAddressResponse[]> => {
  const response = await api.get(
    `${API_ROUTES.GET_STABLE_COIN_WALLET_ADDRESS}?currency=${network}`,
    {
      headers: {
        "x-auth-token": token,
      },
    }
  );
  return response.data.data;
};

export const useGetStableCoinWalletAddress = ({
  network,
  businessId,
  token,
}: {
  network: string;
  businessId: string;
  token: string;
}) => {
  return useQuery({
    queryKey: ["stableCoinWallet", network],
    queryFn: () => FETCH_STABLE_COIN_WALLET({ network, token }),
    enabled: !!businessId && !!token,
  });
};
